import { GluestackUIProvider } from "@gluestack-ui/themed";
import { config } from "../theme/customTheme";

/**
 * Keep the app theme sourced from versioned local files. Depending on the
 * patched @gluestack-ui/config package can silently restore Gluestack's
 * default blue primary palette after dependency upgrades.
 */

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <GluestackUIProvider config={config}>{children}</GluestackUIProvider>;
}
